module.exports = __webpack_public_path__ + "static/img/03.0846872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/03.png
// module id = 02Jl
// module chunks = 1